import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'
import { NotificationProvider } from "./context/NotificationContext";

createRoot(document.getElementById('root')).render(
 
<NotificationProvider>
  <App />
</NotificationProvider> 
)
